import React from 'react'

const Icon = () => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M6.39945 18.6532L5.3457 17.5995L10.9457 11.9995L5.3457 6.39945L6.39945 5.3457L11.9995 10.9457L17.5995 5.3457L18.6532 6.39945L13.0532 11.9995L18.6532 17.5995L17.5995 18.6532L11.9995 13.0532L6.39945 18.6532Z'
        fill='#686867'
      />
    </svg>
  )
}

export default Icon
